import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import List from "@mui/material/List";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Stack, useTheme, IconButton, Box } from "@mui/material";
import SimpleMenu from "./data/SimpleMenu.list";
import ListItem from "./ListItem";
import ChildItems from "./ChildItems";
import { useAppState } from "context/appState.context";

/**
 * PageNavigation component handles the navigation menu of the page.
 * It uses Material-UI components and supports nested menu items with expand/collapse functionality.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} props.open - Boolean indicating whether the navigation menu is open or not.
 * @returns {JSX.Element} The rendered component.
 */
const PageNavigation = ({ open }: { open: boolean }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const secondary = "#757474";
  const routeParams = useParams();
  const { userRole } = useAppState();
  const menus = SimpleMenu(userRole);
  const currentMenuItem = menus.filter(
    (sm) => sm.link === routeParams["*"]
  )[0]?.label;

  useEffect(() => {
    localStorage.setItem(
      "HighlightsMenu",
      currentMenuItem ?? "Location Details"
    );
    localStorage.setItem("Highlights", "");
  }, []);

  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({
    Dashboards: false,
    Settings: false,
    "Portfolio view": false,
  });

  const toggleMenu = (menuName: string) => {
    setOpenMenus((prevState) => ({
      ...prevState,
      [menuName]: !prevState[menuName],
    }));
  };
  return (
    <Box sx={{ width: open ? '100%' : '60px', maxWidth: '100%', overflow: 'hidden', position: 'relative', transition: 'width 0.3s' }}>
      <Box
        sx={{
          transform: 'scale(0.75)',
          transformOrigin: 'top left',
          width: open ? 'calc(100% / 0.75)' : 'calc(60px / 0.75)',
          transition: 'width 0.3s',
        }}
      >
        <Box sx={{ height: "calc((100vh - 130px) / 0.75)", overflowY: "auto", overflowX: "hidden" }}>
          <List data-testid={"navTabs"}>
        {menus.map((item: any) => {
          const isHighlighted =
            item.label === localStorage.getItem("HighlightsMenu");
            return (
              <React.Fragment key={item.id}>
                <Stack direction={"row"}>
                  <ListItem
                    item={item}
                    open={open}
                    isHighlighted={isHighlighted}
                    primary={primary}
                    secondary={secondary}
                  />
                  {item.children && item.children.length > 0 && open && (
                    <IconButton onClick={() => toggleMenu(item.label)}>
                      {!openMenus[item.label] ? (
                        <ExpandMoreIcon />
                      ) : (
                        <ExpandLessIcon />
                      )}
                    </IconButton>
                  )}
                </Stack>
                {item.children && item.children.length > 0 && open && (
                  <ChildItems
                    open={open}
                    dashboardsTabOpen={openMenus[item.label]}
                    primary={primary}
                    secondary={secondary}
                  >
                    {item.children}
                  </ChildItems>
                )}
              </React.Fragment>
            );
        })}
      </List>
        </Box>
      </Box>
    </Box>
  );
};

export default PageNavigation;
